import React from 'react'
import { GroupCircles } from './Selectable.styled'

const SelectableCircles = ({ image = false, children }) => {
  return <GroupCircles image={image}>{children}</GroupCircles>
}

export default SelectableCircles
